import { updatePolicyScan } from './policy-scan-service';
import { IPolicyScan } from 'types';

export const masRequestCallback = (
  policyScanId: string,
  policyId: string,
  phone: string,
  createdBy?: string,
  successPage: number = 4,
  formValues: Record<string, any> = {},
): Promise<any> => {
  return updatePolicyScan({
    id: policyScanId,
    sk: policyId,
    createdBy,
    masSavedQuoteInfo: {
      ...formValues,
      phone,
      page: successPage,
      callbackRequestedAt: new Date().toISOString(),
    },
  } as unknown as IPolicyScan);
};
